// Test IDs for the Due Diligence feature.
export const DD = {
    // Lookup form
    ngoNameInput: 'dd-ngo-name-input',
    countrySelect: 'dd-country-select',
    countrySelectTrigger: 'dd-country-select-trigger',
    countryOption: (code) => `dd-country-option-${code}`,
    regIdInput: 'dd-reg-id-input',
    generateBtn: 'dd-generate-btn',
    resetBtn: 'dd-reset-btn',

    // Progress
    progressLog: 'dd-progress-log',
    progressStep: 'dd-progress-step',

    // Report
    reportContainer: 'dd-report-container',
    reportToc: 'dd-report-toc',
    reportMarkdown: 'dd-report-markdown',
    downloadMarkdownBtn: 'dd-download-md-btn',
    downloadPdfBtn: 'dd-download-pdf-btn',
    newReportBtn: 'dd-new-report-btn',

    // Empty state
    emptyState: 'dd-empty-state',

    // Error
    errorBanner: 'dd-error-banner',
};
